import React from "react";

import type { SettingsEntryId } from "~/settings/feature/settings-entries";

const ProfilePage = React.lazy(() => import("./profile-page"));
const PasswordPage = React.lazy(() => import("./password-page"));
const NotificationsPage = React.lazy(() => import("./notifications-page"));
const ApplicationPage = React.lazy(() => import("./application-page"));
const DeveloperPage = React.lazy(() => import("./developer-page"));
const AiInstructionsPage = React.lazy(() => import("./ai-instructions-page"));
const LinkedAccountsPage = React.lazy(() => import("./linked-accounts-page"));

export const settingsPageElements: { [K in SettingsEntryId]: React.ReactNode } = {
  profile: <ProfilePage />,
  password: <PasswordPage />,
  notifications: <NotificationsPage />,
  application: <ApplicationPage />,
  developer: <DeveloperPage />,
  "ai-instructions": <AiInstructionsPage />,
  "linked-accounts": <LinkedAccountsPage />,
};
